import { useEffect } from 'react';
import type { Variables } from 'graphql-request';
import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import type { UseQueryResult } from '@tanstack/react-query';

import { useGraphQLBasicQuery } from './useGraphQLBasicQuery.hook';
import type { QueryOptions } from './useGraphQLBasicQuery.hook';

interface UseQueryErrorHandlerParams {
  readonly isError: boolean;
  readonly error?: Error | null;
}

export const useQueryErrorHandler = ({
  isError,
  error,
}: Readonly<UseQueryErrorHandlerParams>) => {
  useEffect(() => {
    if (isError) {
      console.error(error);
    }
  }, [isError, error]);
};

export function useGraphQLQuery<
  TResult,
  TVariables extends Variables | undefined,
  TError extends Error = Error,
>(
  document: TypedDocumentNode<TResult, TVariables>,
  variables?: TVariables,
  useQueryOptions?: QueryOptions<TResult, TError>,
): UseQueryResult<TResult> {
  const query = useGraphQLBasicQuery(document, variables, useQueryOptions);

  useQueryErrorHandler(query);

  return query;
}
